import type { IOfficeNew } from "../../../interfaces/models/IOffice";
import {
  isOpaqueIdentifier,
  toReadableLabel,
} from "../../../utils/contactOptionLabel";
import { jurisdictionValueToLabel } from "../../../utils/jurisdiction/structuredJurisdiction";

const USA_COUNTRY_NAMES = new Set([
  "United States of America",
  "United States",
  "USA",
]);

function isUsaOffice(office: IOfficeNew): boolean {
  const countryName = String(office.countryName ?? "").trim();
  if (USA_COUNTRY_NAMES.has(countryName)) {
    return true;
  }

  const country = String(office.country ?? "").trim();
  return country === "USA" || country === "US";
}

function readableOfficePart(value: unknown): string {
  const label = toReadableLabel(value);
  if (!label || isOpaqueIdentifier(label)) {
    return "";
  }
  return label;
}

/** Office label for the Professionals page (filter and Main Office column). */
export function formatProfessionalsOfficeFilterLabel(
  office: IOfficeNew,
): string {
  if (isUsaOffice(office)) {
    const cityState = [office.cityName, office.stateName]
      .map((value) => readableOfficePart(value))
      .filter(Boolean)
      .join(", ");
    if (cityState) {
      return cityState;
    }
  }

  const jurisdiction = readableOfficePart(
    jurisdictionValueToLabel(office.jurisdiction),
  );
  if (jurisdiction) {
    return jurisdiction;
  }

  const jurisdictionName = readableOfficePart(office.jurisdictionName);
  if (jurisdictionName) {
    return jurisdictionName;
  }

  return [office.cityName, office.countryName]
    .map((value) => readableOfficePart(value))
    .filter(Boolean)
    .join(", ");
}
